<template>
  <v-col class="register default-slot" md="7" sm="12">
    <div class="top-icons">
      <div class="top-icons">
        <a class="back-icon" v-on:click="changePage(2)">
          <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
        </a>
      </div>
    </div>
    <h1 class="register-title">Summary & Payment Information</h1>
    <div class="mt-5 ml-10 d-flex justify-start flex-column align-start">
      <h3>
        <span><b>DOG REGISTRATION FEE: </b></span>
        <span>${{price}}</span>
      </h3>
      <h1 class="mt-3">
        <span><b>TOTAL: </b></span>
        <span>${{price}}</span>
      </h1>
    </div>
    <hosted-registration-payment
      :disabled="price === null"
      buttonText="SUBMIT"
      v-on:updatePaymentInfo="submit"
    />
    <p class="steps">STEP <b>3</b> OF <b>3</b></p>
    <footer-text />
  </v-col>
</template>


<script lang="ts">
import Vue from "vue";

import FooterText from "@/components/common/FooterText.vue";
import HostedRegistrationPayment from "@/components/common/HostedRegistrationPayment.vue";

export default Vue.extend({
  name: "SummaryPayment",
  components: { FooterText, HostedRegistrationPayment },
  props: {
    changePage: Function,
    submit: Function,
    price: Number,
  },
  data: function () {
    return {}
  },
});
</script>
